import React from "react";

import styles from "./OfferTypeCard.module.css"
import {OfferType} from "../../../api/generated";
import classnames from "classnames";
import {getOfferTypeName} from "../../modules/offer/modal/createAndUpdate/components/util/offerTypeUtil";

interface OfferTypeCardProps {
    offerType: OfferType
}

export const OfferTypeCard: React.FC<OfferTypeCardProps> = ({
                                                                offerType
                                                            }) => {

    const getOfferTypeCustomStyle = (): string => {
        switch (offerType) {
            case OfferType.NewVehicle:
                return styles.newVehicle
            case OfferType.Service:
                return styles.service
            case OfferType.UsedVehicle:
                return styles.usedVehicle
            default:
                throw new Error(`Unsupported offerType: ${offerType}`)
        }
    }

    return <div className={classnames(styles.wrapper, getOfferTypeCustomStyle())}>
        {getOfferTypeName(offerType)}
    </div>
}
